<template>
  <v-dialog :value="value" width="800px" @input="v => v || close()">
    <v-card>
      <v-card-title>
        <span>「AI MODEL A」のアノテーション変換</span>
        <v-spacer></v-spacer>
        <v-btn light fab small depressed v-on:click="close">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row v-for="i in airprobeErrorTypes.length" :key="i" align="center" justify="center">
          <v-col cols="auto" class="pa-1" style="min-width: 250px; max-width: 250px">
            <span class="text-center">{{ airprobeErrorTypes[i - 1] }}</span>
          </v-col>
          <v-col cols="auto" class="pa-1" style="min-width: 50px; max-width: 50px">
<!--            <v-checkbox-->
<!--                class="my-auto"-->
<!--                v-model="airprobeErrorTypesTransfer[airprobeErrorTypes[i-1]].visible"-->
<!--                label="非表示"-->
<!--                color="red"-->
<!--                hide-details-->
<!--            ></v-checkbox>-->
            <v-icon>
              mdi-arrow-right-bold
            </v-icon>
          </v-col>
          <v-col cols="auto" class="pa-1" style="min-width: 250px; max-width: 250px">
            <v-select
                @change="changeType(airprobeErrorTypes[i-1])"
                v-model="airprobeErrorTypesTransfer[airprobeErrorTypes[i-1]].type"
                :items="errorTypes"
                label="種類"
                outlined
                dense
                item-text="text"
                item-value="value"
                clearable
                hide-details
            ></v-select>
          </v-col>
          <v-col cols class="pa-1">
            <v-select
                @change="changeReason(airprobeErrorTypes[i-1])"
                v-model="airprobeErrorTypesTransfer[airprobeErrorTypes[i-1]].reason"
                :items="errorReasons"
                label="原因"
                outlined
                dense
                item-text="text"
                item-value="value"
                clearable
                hide-details
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="reset">
          初期に戻す
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="transfer" color="primary">
          変換
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {store} from "@/store";

export default {
  name: "AirprobeAnnotationTransferDialog",
  props: ['value', 'airprobeAbnormalities', 'folderId'],
  data() {
    return {
      errorTypes: [
        {text: "ホットスポット", value: "cell"},
        {text: "マルチホットスポット", value: "multicell"},
        {text: "クラスタバイパス", value: "cluster"},
        {text: "モジュール異常", value: "module"},
        {text: "ストリング異常", value: "string"},
        {text: "影", value: "shadow"},
        {text: 'ジャンクションボックス過熱', value: 'junction'},
        {text: 'ＰＩＤ現象の疑い', value: 'pid'},
      ],
      errorReasons: [
        {text: "割れ", value: "crack"},
        {text: "堆積物", value: "sediment"},
        {text: "植生", value: "vegetation"},
      ],
      airprobeErrorTypes: [],
      airprobeErrorTypesTransfer: {
        'Single hotspot affected module': {
          type: 'cell',
          reason: null,
          visible: false
        },
        'Multi hotspot affected module': {
          type: 'multicell',
          reason: null,
          visible: false
        },
        'Bypass diode activated module': {
          type: 'cluster',
          reason: null,
          visible: false
        },
        'Short circuited module': {
          type: 'multicell',
          reason: null,
          visible: false
        },
        'Vegetation growth causing hotspots': {
          type: 'cell',
          reason: 'vegetation',
          visible: false
        },
        'Junction box hotspot affected module': {
          type: 'junction',
          reason: null,
          visible: false
        },
        'Missing module': {
          type: 'module',
          reason: null,
          visible: false
        },
        'LA / TP shadow causing hotspots': {
          type: 'shadow',
          reason: null,
          visible: false
        },
        'Isolated/Underperforming module': {
          type: 'string',
          reason: null,
          visible: false
        },
        'Foreign object shadow causing hotspot': {
          type: 'shadow',
          reason: null,
          visible: false
        },
        'Substring short circuited module': {
          type: 'cluster',
          reason: null,
          visible: false
        },
        'Bird dropping causing hotspot': {
          type: 'cell',
          reason: 'sediment',
          visible: false
        },
        'Inter row shadow affected modules': {
          type: 'shadow',
          reason: null,
          visible: false
        },
        'Inter table shadow affected modules': {
          type: 'shadow',
          reason: null,
          visible: false
        },
        'Cracked glass modules': {
          type: 'cell',
          reason: 'crack',
        },
        'Wrongly inclined modules': {
          type: 'module',
          reason: null,
          visible: false
        },
        'Suspected PID module': {
          type: 'pid',
          reason: null,
          visible: false
        },
        'Hotspot affected and cell mismatch module': {
          type: 'cell',
          reason: null,
          visible: false
        },
        'Soiling causing hotspots': {
          type: 'cell',
          reason: 'sediment',
          visible: false
        },
        'Damaged module': {
          type: 'module',
          reason: null,
          visible: false
        }
      },
    }
  },

  methods: {
    close() {
      store.updateOpenDialog(false);
      this.$emit('input');
    },
    reset() {
      const confirmDialog = {
        title: '初期に戻す確認',
        content: 'AI MODEL Aのアノテーションを初期に戻します。よろしいですか。',
        onAgree: () => {
          this.resetTransfer();
          this.axios
              .put('/api/annotation/airprobe/reset', {folderId: this.folderId})
              .then((response) => {
                this.$emit('reset', response.data);
              })
              .catch(() => {
                store.showErrorDialog('エラーが発生しました。再度試してください。')
              });
        },
        onDisagree: null,
      }
      store.showConfirmDialog(confirmDialog);
    },
    transfer() {
      this.axios
          .put('/api/annotation/airprobe/transfer/' + this.folderId, {transfer: this.airprobeErrorTypesTransfer})
          .then((response) => {
            this.$emit('transfered', response.data);
            this.close();
          }).catch(() => {
            store.showErrorDialog('エラーが発生しました。再度変換してください。');
          });
    },
    changeReason(type) {
      if (!this.airprobeErrorTypesTransfer[type].reason) {
        this.airprobeErrorTypesTransfer[type].reason = null;
      }
    },
    changeType(type) {
      if (!this.airprobeErrorTypesTransfer[type].type) {
        this.airprobeErrorTypesTransfer[type].type = null;
      }
    },
    resetTransfer() {
      this.airprobeErrorTypesTransfer = {
        'Single hotspot affected module': {
          type: 'cell',
          reason: null,
          visible: false
        },
        'Multi hotspot affected module': {
          type: 'multicell',
          reason: null,
          visible: false
        },
        'Bypass diode activated module': {
          type: 'cluster',
          reason: null,
          visible: false
        },
        'Short circuited module': {
          type: 'multicell',
          reason: null,
          visible: false
        },
        'Vegetation growth causing hotspots': {
          type: 'cell',
          reason: 'vegetation',
          visible: false
        },
        'Junction box hotspot affected module': {
          type: 'junction',
          reason: null,
          visible: false
        },
        'Missing module': {
          type: 'module',
          reason: null,
          visible: false
        },
        'LA / TP shadow causing hotspots': {
          type: 'shadow',
          reason: null,
          visible: false
        },
        'Isolated/Underperforming module': {
          type: 'string',
          reason: null,
          visible: false
        },
        'Foreign object shadow causing hotspot': {
          type: 'shadow',
          reason: null,
          visible: false
        },
        'Substring short circuited module': {
          type: 'cluster',
          reason: null,
          visible: false
        },
        'Bird dropping causing hotspot': {
          type: 'cell',
          reason: 'sediment',
          visible: false
        },
        'Inter row shadow affected modules': {
          type: 'shadow',
          reason: null,
          visible: false
        },
        'Inter table shadow affected modules': {
          type: 'shadow',
          reason: null,
          visible: false
        },
        'Cracked glass modules': {
          type: 'cell',
          reason: 'crack',
        },
        'Wrongly inclined modules': {
          type: 'module',
          reason: null,
          visible: false
        },
        'Suspected PID module': {
          type: 'pid',
          reason: null,
          visible: false
        },
        'Hotspot affected and cell mismatch module': {
          type: 'cell',
          reason: null,
          visible: false
        },
        'Soiling causing hotspots': {
          type: 'cell',
          reason: 'sediment',
          visible: false
        },
        'Damaged module': {
          type: 'module',
          reason: null,
          visible: false
        }
      };
      this.airprobeAbnormalities.airprobe_abnormality.list.forEach((abnormality) => {
        if (!(abnormality.airprobe_type in this.airprobeErrorTypesTransfer)) {
          this.airprobeErrorTypesTransfer[abnormality.airprobe_type] = {
            type: null,
            reason: null,
            visible: true,
          };
        }
      });
    }
  },

  watch: {
    value(value) {
      if (value) {
        store.updateOpenDialog(true);
        this.airprobeErrorTypes = [];
        this.airprobeAbnormalities.airprobe_abnormality.list.forEach((abnormality) => {
          if (!(abnormality.airprobe_type in this.airprobeErrorTypesTransfer) && abnormality.airprobe_type) {
            this.airprobeErrorTypesTransfer[abnormality.airprobe_type] = {
              type: abnormality.type,
              reason: abnormality.reason,
              visible: !abnormality.visible
            };
          }
          if (!this.airprobeErrorTypes.includes(abnormality.airprobe_type) && abnormality.airprobe_type) {
            this.airprobeErrorTypes.push(abnormality.airprobe_type);
          }
        });
        // this.axios.get('/api/annotation/airprobe/' + this.folderId).then((response) => {
        //   this.airprobeErrorTypes = response.data.airprobe_abnormality_transfer.list;
        //   this.airprobeAbnormalities.airprobe_abnormality.list.forEach((abnormality) => {
        //     if (!(this.airprobeErrorTypes.some(a => a.airprobeType === abnormality.airprobeType))){
        //       this.airprobeErrorTypes.push({airprobeType: abnormality.airprobeType, type: null, reason: null});
        //     }
        //   });
        // });
      }
    }
  }
}
</script>

<style scoped>

</style>
